import { render, staticRenderFns } from "./BundleCallback.vue?vue&type=template&id=518bf58e&scoped=true"
import script from "./BundleCallback.vue?vue&type=script&lang=js"
export * from "./BundleCallback.vue?vue&type=script&lang=js"
import style0 from "./BundleCallback.vue?vue&type=style&index=0&id=518bf58e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518bf58e",
  null
  
)

export default component.exports